import { ComunidadTiposGastos } from "./comunidad";

export class TipoGasto {
  constructor(
    public readonly Id: number,
    public readonly Codigo: string | null,
    public readonly Nombre: string | null,
    public readonly EsRecurrente: boolean,
    public readonly PeriodicidadRecurrencia: number | null,
    public Comunidades: ComunidadTiposGastos[],
    public readonly ComunidadesNombre: string | null,
    public Activo: boolean
  ) {}
}

export class SearchTipoGastoRequest {
  constructor(
    public readonly PageSize: number | null,
    public readonly PageNumber: number | null,
    public readonly OrderAscending: boolean | null,
    public readonly OrderFieldName: string | null,
    public readonly Nombre: string | null,
    public readonly Codigo: string | null,
    public readonly ComunidadId: number | null,
    public readonly VerSoloRecurrentes: boolean | null,
    public readonly VerSoloActivos: boolean | null
  ) {}
}

export class SaveTipoGastoDto {
  constructor(
    public Nombre: string | null,
    public Codigo: string | null,
    public readonly EsRecurrente: boolean | null,
    public readonly PeriodicidadRecurrencia: number | null,
    public readonly Comunidades: ComunidadTiposGastos[],
    public Activo: boolean
  ) {}
}

export class SearchTipoGastoResponse {
  constructor(
    public readonly count: number,
    public readonly result: TipoGasto[]
  ) {}
}
